export const SAVE_BUTTON_LABEL = "Save";
export const CANCEL_BUTTON_LABEL = "Cancel";
export const BACK_BUTTON_LABEL = "Back";
export const SYNCING_WITH_DOCUMENT_LABEL = "Syncing with the document";

export const PRIMARY_BUTTON_CLASS = "flex h-[22px] flex-shrink-0 items-center whitespace-nowrap rounded bg-primary px-2.5 text-[11px] font-medium text-white disabled:opacity-50";
export const SECONDARY_BUTTON_CLASS = "flex h-[22px] flex-shrink-0 items-center whitespace-nowrap rounded border border-[#D4D3D0] bg-white px-2.5 text-[11px] text-[#171715] hover:bg-[#F8F9FA]";
